import React, { useRef } from 'react'
import { useOpacityToggle } from '@hooks'
import { ChangeOpacityComponents } from 'game-ui-types'

interface EQSpinButtonSVGProps {
    text?: string
}

const EQSpinButtonSVG: React.FC<EQSpinButtonSVGProps> = ({ text = '' }) => {
    const spinButtonText = useRef<SVGTextElement | null>(null)

    useOpacityToggle(ChangeOpacityComponents.SPIN_BUTTON_TEXT, spinButtonText)

    return (
        <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask
                id="mask0_11947_66807"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="200"
                height="200"
            >
                <path
                    d="M192.388 61.7317C197.413 73.8642 200 86.8678 200 100L100 100L192.388 61.7317Z"
                    fill="#D9D9D9"
                />
                <path
                    d="M138.268 7.61205C150.401 12.6375 161.425 20.0035 170.711 29.2893L100 100L138.268 7.61205Z"
                    fill="#D9D9D9"
                />
                <path
                    d="M7.61206 61.7316C12.6375 49.5991 20.0035 38.5752 29.2893 29.2893L100 100L7.61206 61.7316Z"
                    fill="#D9D9D9"
                />
                <path
                    d="M7.61205 138.268C2.58659 126.136 8.24483e-06 113.132 0 100L100 100L7.61205 138.268Z"
                    fill="#D9D9D9"
                />
                <path
                    d="M61.7317 192.388C49.5991 187.362 38.5752 179.997 29.2893 170.711L100 100L61.7317 192.388Z"
                    fill="#D9D9D9"
                />
                <path
                    d="M138.268 192.388C126.136 197.413 113.132 200 100 200L100 100L138.268 192.388Z"
                    fill="#D9D9D9"
                />
                <path
                    d="M192.385 138.275C187.359 150.407 179.992 161.43 170.706 170.716L100 100L192.385 138.275Z"
                    fill="#D9D9D9"
                />
                <path
                    d="M61.7317 7.61203C73.8643 2.58657 86.8679 -6.41851e-06 100 0L100 100L61.7317 7.61203Z"
                    fill="#D9D9D9"
                />
            </mask>
            <g mask="url(#mask0_11947_66807)">
                <circle cx="100" cy="100" r="100" fill="url(#paint0_radial_11947_66807)" />
            </g>
            <mask
                id="mask1_11947_66807"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="200"
                height="200"
            >
                <path d="M200 100C200 113.132 197.413 126.136 192.388 138.268L100 100H200Z" fill="#D9D9D9" />
                <path
                    d="M170.711 29.2893C179.997 38.5752 187.362 49.5991 192.388 61.7317L100 100L170.711 29.2893Z"
                    fill="#D9D9D9"
                />
                <path d="M100 0C113.132 1.566e-07 126.136 2.58658 138.268 7.61205L100 100L100 0Z" fill="#D9D9D9" />
                <path
                    d="M29.2893 29.2893C38.5752 20.0035 49.5991 12.6375 61.7316 7.61207L100 100L29.2893 29.2893Z"
                    fill="#D9D9D9"
                />
                <path d="M0 100C1.14805e-06 86.8678 2.58657 73.8642 7.61203 61.7317L100 100L0 100Z" fill="#D9D9D9" />
                <path
                    d="M29.2893 170.711C20.0035 161.425 12.6375 150.401 7.61207 138.268L100 100L29.2893 170.711Z"
                    fill="#D9D9D9"
                />
                <path d="M100 200C86.8678 200 73.8642 197.413 61.7317 192.388L100 100L100 200Z" fill="#D9D9D9" />
                <path
                    d="M170.711 170.711C161.425 179.997 150.401 187.362 138.268 192.388L100 100L170.711 170.711Z"
                    fill="#D9D9D9"
                />
            </mask>
            <g mask="url(#mask1_11947_66807)">
                <circle cx="100" cy="100" r="100" fill="url(#paint1_radial_11947_66807)" />
            </g>
            <mask
                id="mask2_11947_66807"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="200"
                height="200"
            >
                <circle cx="100" cy="100" r="100" fill="#010101" />
            </mask>
            <g mask="url(#mask2_11947_66807)">
                <mask
                    id="mask3_11947_66807"
                    mask-type="alpha"
                    maskUnits="userSpaceOnUse"
                    x="90"
                    y="0"
                    width="18"
                    height="200"
                >
                    <rect x="90" width="18" height="200" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask3_11947_66807)">
                    <circle cx="99" cy="100" r="100" fill="#5F370D" />
                </g>
                <mask
                    id="mask4_11947_66807"
                    mask-type="alpha"
                    maskUnits="userSpaceOnUse"
                    x="90"
                    y="0"
                    width="6"
                    height="200"
                >
                    <rect x="90" width="6" height="200" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask4_11947_66807)">
                    <circle cx="94" cy="100" r="100" fill="url(#paint2_radial_11947_66807)" />
                </g>
                <mask
                    id="mask5_11947_66807"
                    mask-type="alpha"
                    maskUnits="userSpaceOnUse"
                    x="102"
                    y="0"
                    width="6"
                    height="200"
                >
                    <rect x="102" width="6" height="200" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask5_11947_66807)">
                    <circle cx="106" cy="100" r="100" fill="url(#paint3_radial_11947_66807)" />
                </g>
                <mask
                    id="mask6_11947_66807"
                    mask-type="alpha"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="91"
                    width="200"
                    height="18"
                >
                    <rect x="200" y="91" width="18" height="200" transform="rotate(90 200 91)" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask6_11947_66807)">
                    <circle cx="100" cy="100" r="100" transform="rotate(90 100 100)" fill="#5F370D" />
                </g>
                <mask
                    id="mask7_11947_66807"
                    mask-type="alpha"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="91"
                    width="200"
                    height="6"
                >
                    <rect x="200" y="91" width="6" height="200" transform="rotate(90 200 91)" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask7_11947_66807)">
                    <circle
                        cx="100"
                        cy="95"
                        r="100"
                        transform="rotate(90 100 95)"
                        fill="url(#paint4_radial_11947_66807)"
                    />
                </g>
                <mask
                    id="mask8_11947_66807"
                    mask-type="alpha"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="103"
                    width="200"
                    height="6"
                >
                    <rect x="200" y="103" width="6" height="200" transform="rotate(90 200 103)" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask8_11947_66807)">
                    <circle
                        cx="100"
                        cy="107"
                        r="100"
                        transform="rotate(90 100 107)"
                        fill="url(#paint5_radial_11947_66807)"
                    />
                </g>
                <mask
                    id="mask9_11947_66807"
                    mask-type="alpha"
                    maskUnits="userSpaceOnUse"
                    x="22"
                    y="22"
                    width="156"
                    height="156"
                >
                    <rect
                        x="164.347"
                        y="22.9258"
                        width="18"
                        height="200"
                        transform="rotate(45 164.347 22.9258)"
                        fill="#D9D9D9"
                    />
                </mask>
                <g mask="url(#mask9_11947_66807)">
                    <circle cx="100" cy="100" r="100" transform="rotate(45 100 100)" fill="#5F370D" />
                </g>
                <mask
                    id="mask10_11947_66807"
                    mask-type="alpha"
                    maskUnits="userSpaceOnUse"
                    x="22"
                    y="22"
                    width="147"
                    height="147"
                >
                    <rect
                        x="164.347"
                        y="22.9258"
                        width="6"
                        height="200"
                        transform="rotate(45 164.347 22.9258)"
                        fill="#D9D9D9"
                    />
                </mask>
                <g mask="url(#mask10_11947_66807)">
                    <circle
                        cx="96.4648"
                        cy="96.4649"
                        r="100"
                        transform="rotate(45 96.4648 96.4649)"
                        fill="url(#paint6_radial_11947_66807)"
                    />
                </g>
                <mask
                    id="mask11_11947_66807"
                    mask-type="alpha"
                    maskUnits="userSpaceOnUse"
                    x="31"
                    y="31"
                    width="147"
                    height="147"
                >
                    <rect
                        x="172.832"
                        y="31.411"
                        width="6"
                        height="200"
                        transform="rotate(45 172.832 31.411)"
                        fill="#D9D9D9"
                    />
                </mask>
                <g mask="url(#mask11_11947_66807)">
                    <circle
                        cx="104.95"
                        cy="104.95"
                        r="100"
                        transform="rotate(45 104.95 104.95)"
                        fill="url(#paint7_radial_11947_66807)"
                    />
                </g>
                <mask
                    id="mask12_11947_66807"
                    mask-type="alpha"
                    maskUnits="userSpaceOnUse"
                    x="22"
                    y="22"
                    width="156"
                    height="156"
                >
                    <rect
                        x="177.074"
                        y="164.347"
                        width="18"
                        height="200"
                        transform="rotate(135 177.074 164.347)"
                        fill="#D9D9D9"
                    />
                </mask>
                <g mask="url(#mask12_11947_66807)">
                    <circle cx="99.9995" cy="100" r="100" transform="rotate(135 99.9995 100)" fill="#5F370D" />
                </g>
                <mask
                    id="mask13_11947_66807"
                    mask-type="alpha"
                    maskUnits="userSpaceOnUse"
                    x="31"
                    y="22"
                    width="147"
                    height="147"
                >
                    <rect
                        x="177.074"
                        y="164.347"
                        width="6"
                        height="200"
                        transform="rotate(135 177.074 164.347)"
                        fill="#D9D9D9"
                    />
                </mask>
                <g mask="url(#mask13_11947_66807)">
                    <circle
                        cx="103.535"
                        cy="96.4645"
                        r="100"
                        transform="rotate(135 103.535 96.4645)"
                        fill="url(#paint8_radial_11947_66807)"
                    />
                </g>
                <mask
                    id="mask14_11947_66807"
                    mask-type="alpha"
                    maskUnits="userSpaceOnUse"
                    x="22"
                    y="31"
                    width="147"
                    height="147"
                >
                    <rect
                        x="168.589"
                        y="172.832"
                        width="6"
                        height="200"
                        transform="rotate(135 168.589 172.832)"
                        fill="#D9D9D9"
                    />
                </mask>
                <g mask="url(#mask14_11947_66807)">
                    <circle
                        cx="95.0493"
                        cy="104.95"
                        r="100"
                        transform="rotate(135 95.0493 104.95)"
                        fill="url(#paint9_radial_11947_66807)"
                    />
                </g>
            </g>
            <circle cx="100" cy="100" r="86" fill="#010101" />
            <circle
                cx="100"
                cy="100"
                r="84"
                fill="url(#paint10_radial_11947_66807)"
                stroke="#464646"
                stroke-width="2"
            />
            <mask id="path-46-inside-1_11947_66807" fill="white">
                <path d="M99.8789 42C131.632 42 157.506 67.4457 158.646 99.2578C158.652 99.4537 158.607 99.6386 158.523 99.8008H169.765C171.629 99.801 172.673 101.96 171.512 103.426L150.356 130.175C149.458 131.31 147.733 131.305 146.845 130.158L126.079 103.409L126.085 103.415C124.946 101.944 125.99 99.8008 127.85 99.8008H139.149C139.078 99.66 139.033 99.5029 139.025 99.3359C137.992 78.5176 120.901 61.9171 99.8848 61.8164C90.086 61.8165 79.5336 66.6676 72.2695 73.4092C71.7838 73.8568 71.0185 73.7786 70.6221 73.2471L60.1084 59.1035C59.7678 58.6447 59.8241 58.0013 60.2373 57.6152C71.0077 47.5896 85.1612 42.0001 99.8789 42Z" />
            </mask>
            <path
                d="M99.8789 42C131.632 42 157.506 67.4457 158.646 99.2578C158.652 99.4537 158.607 99.6386 158.523 99.8008H169.765C171.629 99.801 172.673 101.96 171.512 103.426L150.356 130.175C149.458 131.31 147.733 131.305 146.845 130.158L126.079 103.409L126.085 103.415C124.946 101.944 125.99 99.8008 127.85 99.8008H139.149C139.078 99.66 139.033 99.5029 139.025 99.3359C137.992 78.5176 120.901 61.9171 99.8848 61.8164C90.086 61.8165 79.5336 66.6676 72.2695 73.4092C71.7838 73.8568 71.0185 73.7786 70.6221 73.2471L60.1084 59.1035C59.7678 58.6447 59.8241 58.0013 60.2373 57.6152C71.0077 47.5896 85.1612 42.0001 99.8789 42Z"
                fill="url(#paint11_linear_11947_66807)"
            />
            <path
                d="M99.8789 42L99.8789 41L99.8789 41L99.8789 42ZM158.646 99.2578L159.645 99.2229L159.645 99.222L158.646 99.2578ZM158.523 99.8008L157.635 99.3427L156.883 100.801H158.523V99.8008ZM169.765 99.8008L169.765 98.8008H169.765V99.8008ZM171.512 103.426L170.728 102.805L170.727 102.805L171.512 103.426ZM150.356 130.175L151.141 130.795L151.141 130.795L150.356 130.175ZM146.845 130.158L147.635 129.546L147.635 129.545L146.845 130.158ZM126.079 103.409L126.786 102.702L125.289 104.022L126.079 103.409ZM126.085 103.415L125.378 104.122L126.876 102.803L126.085 103.415ZM139.149 99.8008V100.801H140.781L140.041 99.3471L139.149 99.8008ZM139.025 99.3359L140.024 99.2891L140.024 99.2864L139.025 99.3359ZM99.8848 61.8164L99.8896 60.8164L99.8848 60.8164L99.8848 61.8164ZM72.2695 73.4092L72.9472 74.1446L72.9498 74.1422L72.2695 73.4092ZM70.6221 73.2471L69.8195 73.8437L69.8205 73.845L70.6221 73.2471ZM60.1084 59.1035L59.3055 59.6996L59.3058 59.7001L60.1084 59.1035ZM60.2373 57.6152L59.556 56.8833L59.5546 56.8845L60.2373 57.6152ZM99.8789 42V43C131.082 43 156.526 68.0077 157.646 99.2936L158.646 99.2578L159.645 99.222C158.487 66.8836 132.182 41 99.8789 41V42ZM158.646 99.2578L157.646 99.2927C157.647 99.31 157.643 99.3258 157.635 99.3427L158.523 99.8008L159.412 100.259C159.571 99.9514 159.658 99.5974 159.645 99.2229L158.646 99.2578ZM158.523 99.8008V100.801H169.765V99.8008V98.8008H158.523V99.8008ZM169.765 99.8008L169.765 100.801C170.791 100.801 171.371 101.993 170.728 102.805L171.512 103.426L172.296 104.047C173.975 101.927 172.468 98.8011 169.765 98.8008L169.765 99.8008ZM171.512 103.426L170.727 102.805L149.572 129.554L150.356 130.175L151.141 130.795L172.296 104.046L171.512 103.426ZM150.356 130.175L149.572 129.554C149.075 130.182 148.124 130.177 147.635 129.546L146.845 130.158L146.054 130.771C147.341 132.432 149.84 132.438 151.141 130.795L150.356 130.175ZM146.845 130.158L147.635 129.545L126.869 102.796L126.079 103.409L125.289 104.022L146.055 130.771L146.845 130.158ZM126.079 103.409L125.372 104.116L125.378 104.122L126.085 103.415L126.792 102.708L126.786 102.702L126.079 103.409ZM126.085 103.415L126.876 102.803C126.242 101.984 126.828 100.801 127.85 100.801V99.8008V98.8008C125.153 98.8008 123.65 101.904 125.294 104.027L126.085 103.415ZM127.85 99.8008V100.801H139.149V99.8008V98.8008H127.85V99.8008ZM139.149 99.8008L140.041 99.3471C140.03 99.3256 140.025 99.3066 140.024 99.2891L139.025 99.3359L138.026 99.3828C138.041 99.6993 138.126 99.9944 138.258 100.254L139.149 99.8008ZM139.025 99.3359L140.024 99.2864C138.965 77.9435 121.443 60.9197 99.8896 60.8164L99.8848 61.8164L99.88 62.8164C120.359 62.9145 137.02 79.0917 138.027 99.3855L139.025 99.3359ZM99.8848 61.8164L99.8848 60.8164C89.7887 60.8165 79.0024 65.7962 71.5893 72.6762L72.2695 73.4092L72.9498 74.1422C80.0647 67.539 90.3832 62.8165 99.8848 62.8164L99.8848 61.8164ZM72.2695 73.4092L71.5919 72.6738C71.552 72.7105 71.4732 72.7157 71.4237 72.6492L70.6221 73.2471L69.8205 73.845C70.5638 74.8414 72.0156 75.003 72.9471 74.1446L72.2695 73.4092ZM70.6221 73.2471L71.4246 72.6505L60.911 58.5069L60.1084 59.1035L59.3058 59.7001L69.8195 73.8437L70.6221 73.2471ZM60.1084 59.1035L60.9113 58.5074C60.87 58.4518 60.8834 58.3802 60.92 58.3459L60.2373 57.6152L59.5546 56.8845C58.7649 57.6224 58.6656 58.8377 59.3055 59.6996L60.1084 59.1035ZM60.2373 57.6152L60.9187 58.3472C71.5046 48.4931 85.415 43.0001 99.8789 43L99.8789 42L99.8789 41C84.9074 41.0001 70.5107 46.686 59.556 56.8833L60.2373 57.6152Z"
                fill="url(#paint12_linear_11947_66807)"
                mask="url(#path-46-inside-1_11947_66807)"
            />
            <mask id="path-48-inside-2_11947_66807" fill="white">
                <path d="M50.6836 69.741C51.5825 68.6053 53.3075 68.6166 54.1953 69.7634L74.916 96.5457C76.055 98.0171 75.0048 100.154 73.1455 100.154L61.8379 100.135C61.91 100.277 61.955 100.435 61.9629 100.602C62.9623 121.421 80.0251 138.049 101.041 138.183C110.84 138.2 121.404 133.366 128.68 126.635C129.165 126.188 129.935 126.266 130.326 126.798L140.812 140.958C141.147 141.416 141.097 142.06 140.679 142.446C129.891 152.455 115.726 158.022 101.008 158C69.2547 157.949 43.426 132.459 42.3428 100.647C42.3359 100.452 42.3798 100.267 42.4629 100.105L31.2305 100.088C29.366 100.082 28.3277 97.9225 29.4883 96.4568L50.6836 69.741Z" />
            </mask>
            <path
                d="M50.6836 69.741C51.5825 68.6053 53.3075 68.6166 54.1953 69.7634L74.916 96.5457C76.055 98.0171 75.0048 100.154 73.1455 100.154L61.8379 100.135C61.91 100.277 61.955 100.435 61.9629 100.602C62.9623 121.421 80.0251 138.049 101.041 138.183C110.84 138.2 121.404 133.366 128.68 126.635C129.165 126.188 129.935 126.266 130.326 126.798L140.812 140.958C141.147 141.416 141.097 142.06 140.679 142.446C129.891 152.455 115.726 158.022 101.008 158C69.2547 157.949 43.426 132.459 42.3428 100.647C42.3359 100.452 42.3798 100.267 42.4629 100.105L31.2305 100.088C29.366 100.082 28.3277 97.9225 29.4883 96.4568L50.6836 69.741Z"
                fill="url(#paint13_linear_11947_66807)"
            />
            <path
                d="M50.6836 69.741L51.467 70.3625L51.4677 70.3616L50.6836 69.741ZM54.1953 69.7634L54.9862 69.1515L54.9861 69.1513L54.1953 69.7634ZM74.916 96.5457L74.1251 97.1576L74.1252 97.1578L74.916 96.5457ZM73.1455 100.154L73.1439 101.154H73.1455V100.154ZM61.8379 100.135L61.8395 99.1355L60.2032 99.1328L60.9472 100.59L61.8379 100.135ZM61.9629 100.602L60.964 100.649L60.964 100.65L61.9629 100.602ZM101.041 138.183L101.035 139.183L101.039 139.183L101.041 138.183ZM128.68 126.635L128.002 125.9L128.001 125.901L128.68 126.635ZM130.326 126.798L129.521 127.39L129.523 127.393L130.326 126.798ZM140.812 140.958L141.62 140.368L141.616 140.363L140.812 140.958ZM140.679 142.446L140.001 141.711L139.999 141.713L140.679 142.446ZM101.008 158L101.006 159L101.006 159L101.008 158ZM42.3428 100.647L43.3422 100.613L43.3422 100.612L42.3428 100.647ZM42.4629 100.105L43.3525 100.562L44.099 99.1078L42.4645 99.1052L42.4629 100.105ZM31.2305 100.088L31.2273 101.088L31.2289 101.088L31.2305 100.088ZM29.4883 96.4568L28.7049 95.8353L28.7043 95.836L29.4883 96.4568ZM50.6836 69.741L51.4677 70.3616C51.9621 69.737 52.913 69.7406 53.4046 70.3756L54.1953 69.7634L54.9861 69.1513C53.7021 67.4926 51.203 67.4736 49.8995 69.1203L50.6836 69.741ZM54.1953 69.7634L53.4044 70.3753L74.1251 97.1576L74.916 96.5457L75.7069 95.9337L54.9862 69.1515L54.1953 69.7634ZM74.916 96.5457L74.1252 97.1578C74.7549 97.9712 74.1748 99.1541 73.1455 99.1541V100.154V101.154C75.8348 101.154 77.3551 98.063 75.7068 95.9336L74.916 96.5457ZM73.1455 100.154L73.1471 99.1541L61.8395 99.1355L61.8379 100.135L61.8362 101.135L73.1439 101.154L73.1455 100.154ZM61.8379 100.135L60.9472 100.59C60.9586 100.612 60.9632 100.632 60.964 100.649L61.9629 100.602L62.9618 100.555C62.9468 100.237 62.8614 99.941 62.7285 99.6808L61.8379 100.135ZM61.9629 100.602L60.964 100.65C61.9887 121.993 79.4815 139.045 101.035 139.183L101.041 138.183L101.047 137.183C80.5686 137.052 63.936 120.848 62.9617 100.554L61.9629 100.602ZM101.041 138.183L101.039 139.183C111.135 139.201 121.934 134.238 129.359 127.37L128.68 126.635L128.001 125.901C120.875 132.494 110.544 137.2 101.043 137.183L101.041 138.183ZM128.68 126.635L129.357 127.371C129.4 127.331 129.479 127.334 129.521 127.39L130.326 126.798L131.132 126.205C130.391 125.199 128.931 125.045 128.002 125.9L128.68 126.635ZM130.326 126.798L129.523 127.393L140.009 141.553L140.812 140.958L141.616 140.363L131.13 126.202L130.326 126.798ZM140.812 140.958L140.005 141.547C140.026 141.576 140.035 141.61 140.032 141.643C140.029 141.675 140.017 141.696 140.001 141.711L140.679 142.446L141.357 143.181C142.163 142.437 142.243 141.221 141.62 140.368L140.812 140.958ZM140.679 142.446L139.999 141.713C129.396 151.551 115.474 157.022 101.009 157L101.008 158L101.006 159C115.978 159.023 130.387 153.36 141.359 143.179L140.679 142.446ZM101.008 158L101.009 157C69.8065 156.95 44.4075 131.899 43.3422 100.613L42.3428 100.647L41.3434 100.681C42.4445 133.02 68.703 158.948 101.006 159L101.008 158ZM42.3428 100.647L43.3422 100.612C43.3414 100.591 43.3459 100.575 43.3525 100.562L42.4629 100.105L41.5733 99.6485C41.4137 99.9594 41.3304 100.313 41.3434 100.682L42.3428 100.647ZM42.4629 100.105L42.4645 99.1052L31.232 99.0876L31.2305 100.088L31.2289 101.088L42.4613 101.105L42.4629 100.105ZM31.2305 100.088L31.2336 99.0877C30.2077 99.0844 29.6274 97.8919 30.2723 97.0776L29.4883 96.4568L28.7043 95.836C27.0279 97.9531 28.5243 101.079 31.2273 101.088L31.2305 100.088ZM29.4883 96.4568L30.2717 97.0783L51.467 70.3625L50.6836 69.741L49.9002 69.1194L28.7049 95.8353L29.4883 96.4568Z"
                fill="url(#paint14_linear_11947_66807)"
                mask="url(#path-48-inside-2_11947_66807)"
            />
            <circle cx="100" cy="100" r="98.5" stroke="url(#paint15_linear_11947_66807)" stroke-width="3" />
            {/* Dynamic Text */}
            <text ref={spinButtonText}>
                <textPath xlinkHref="#text-circle" startOffset="50%" textAnchor="middle">
                    <tspan id="turbo-spin" className="st0">
                        {text}
                    </tspan>
                </textPath>
            </text>
            <defs>
                <style>
                    {`
          .st0 {
            fill: #fff;
            font-family: Roboto-Bold, Roboto;
            font-size: 20px;
            font-weight: 700;
          }
          `}
                </style>
                <path id="text-circle" d="M 100 176 a 75 75 90 0 1 0 -150 a 75 75 90 0 1 0 150 Z" />
                <radialGradient
                    id="paint0_radial_11947_66807"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(100 100) rotate(90) scale(100)"
                >
                    <stop />
                    <stop offset="0.87" stop-color="#622B00" />
                    <stop offset="0.91" stop-color="#F66C04" />
                    <stop offset="0.97" stop-color="#562702" />
                </radialGradient>
                <radialGradient
                    id="paint1_radial_11947_66807"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(100 100) rotate(90) scale(100)"
                >
                    <stop />
                    <stop offset="0.87" stop-color="#072252" />
                    <stop offset="0.91" stop-color="#2CC0FF" />
                    <stop offset="0.97" stop-color="#1B197A" />
                </radialGradient>
                <radialGradient
                    id="paint2_radial_11947_66807"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(94 100) rotate(90) scale(100)"
                >
                    <stop />
                    <stop offset="0.87" stop-color="#775000" />
                    <stop offset="0.91" stop-color="#FFE570" />
                    <stop offset="0.97" stop-color="#8A6B05" />
                </radialGradient>
                <radialGradient
                    id="paint3_radial_11947_66807"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(106 100) rotate(90) scale(100)"
                >
                    <stop />
                    <stop offset="0.87" stop-color="#775000" />
                    <stop offset="0.91" stop-color="#FFE570" />
                    <stop offset="0.97" stop-color="#8A6B05" />
                </radialGradient>
                <radialGradient
                    id="paint4_radial_11947_66807"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(100 95) rotate(90) scale(100)"
                >
                    <stop />
                    <stop offset="0.87" stop-color="#775000" />
                    <stop offset="0.91" stop-color="#FFE570" />
                    <stop offset="0.97" stop-color="#8A6B05" />
                </radialGradient>
                <radialGradient
                    id="paint5_radial_11947_66807"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(100 107) rotate(90) scale(100)"
                >
                    <stop />
                    <stop offset="0.87" stop-color="#775000" />
                    <stop offset="0.91" stop-color="#FFE570" />
                    <stop offset="0.97" stop-color="#8A6B05" />
                </radialGradient>
                <radialGradient
                    id="paint6_radial_11947_66807"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(96.4648 96.4649) rotate(90) scale(100)"
                >
                    <stop />
                    <stop offset="0.87" stop-color="#775000" />
                    <stop offset="0.91" stop-color="#FFE570" />
                    <stop offset="0.97" stop-color="#8A6B05" />
                </radialGradient>
                <radialGradient
                    id="paint7_radial_11947_66807"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(104.95 104.95) rotate(90) scale(100)"
                >
                    <stop />
                    <stop offset="0.87" stop-color="#775000" />
                    <stop offset="0.91" stop-color="#FFE570" />
                    <stop offset="0.97" stop-color="#8A6B05" />
                </radialGradient>
                <radialGradient
                    id="paint8_radial_11947_66807"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(103.535 96.4645) rotate(90) scale(100)"
                >
                    <stop />
                    <stop offset="0.87" stop-color="#775000" />
                    <stop offset="0.91" stop-color="#FFE570" />
                    <stop offset="0.97" stop-color="#8A6B05" />
                </radialGradient>
                <radialGradient
                    id="paint9_radial_11947_66807"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(95.0493 104.95) rotate(90) scale(100)"
                >
                    <stop />
                    <stop offset="0.87" stop-color="#775000" />
                    <stop offset="0.91" stop-color="#FFE570" />
                    <stop offset="0.97" stop-color="#8A6B05" />
                </radialGradient>
                <radialGradient
                    id="paint10_radial_11947_66807"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(100 100) rotate(90) scale(85)"
                >
                    <stop offset="0.05" stop-color="#FF5900" />
                    <stop offset="0.565" />
                </radialGradient>
                <linearGradient
                    id="paint11_linear_11947_66807"
                    x1="59.8857"
                    y1="86.5111"
                    x2="171.999"
                    y2="86.5111"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stop-color="#93490B" />
                    <stop offset="0.4" stop-color="#FEE880" />
                    <stop offset="0.495586" stop-color="#FFFBE6" />
                    <stop offset="0.600586" stop-color="#FEE880" />
                    <stop offset="1" stop-color="#93490B" />
                </linearGradient>
                <linearGradient
                    id="paint12_linear_11947_66807"
                    x1="115.943"
                    y1="42"
                    x2="115.943"
                    y2="131.022"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stop-color="#93490B" />
                    <stop offset="0.36" stop-color="#FEE880" />
                    <stop offset="0.51" stop-color="#FFFBE6" />
                    <stop offset="0.63" stop-color="#FEE880" />
                    <stop offset="1" stop-color="#93490B" />
                </linearGradient>
                <linearGradient
                    id="paint13_linear_11947_66807"
                    x1="29"
                    y1="113.448"
                    x2="141.032"
                    y2="113.448"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stop-color="#93490B" />
                    <stop offset="0.4" stop-color="#FEE880" />
                    <stop offset="0.495586" stop-color="#FFFBE6" />
                    <stop offset="0.600586" stop-color="#FEE880" />
                    <stop offset="1" stop-color="#93490B" />
                </linearGradient>
                <linearGradient
                    id="paint14_linear_11947_66807"
                    x1="85.0162"
                    y1="68.8962"
                    x2="85.0162"
                    y2="158"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stop-color="#93490B" />
                    <stop offset="0.36" stop-color="#FEE880" />
                    <stop offset="0.51" stop-color="#FFFBE6" />
                    <stop offset="0.63" stop-color="#FEE880" />
                    <stop offset="1" stop-color="#93490B" />
                </linearGradient>
                <linearGradient
                    id="paint15_linear_11947_66807"
                    x1="100"
                    y1="0"
                    x2="100"
                    y2="200"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stop-color="#FCF1BD" />
                    <stop offset="0.22" stop-color="#E5BC53" />
                    <stop offset="0.475" stop-color="#FFF0BE" />
                    <stop offset="0.76" stop-color="#E5BC53" />
                    <stop offset="1" stop-color="#FCF1BD" />
                </linearGradient>
            </defs>
        </svg>
    )
}

export default EQSpinButtonSVG
